var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.stock.status === 'IN_STOCK' || _vm.stock.message)?_c('span',{staticClass:"bullet-stock font-weight-semibold mb-0 ml-0",class:_vm.color,domProps:{"textContent":_vm._s(_vm.currentStock)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }